var _excluded = ["type"];
function _objectWithoutProperties(source, excluded) { if (source == null)
    return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
            continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
        target[key] = source[key];
    }
} return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
import axios from 'api/axios';
import { getAccountChangeEmailInvitationPath, getAccountEmailChangePath, getAccountPasswordPath, getAccountPath, getAccountResendEmailPath } from './apiPaths';
export var getAccountGetRequest = function getAccountGetRequest() {
    return axios.get(getAccountPath());
};
export var getAccountPasswordPutRequest = function getAccountPasswordPutRequest(body) {
    return axios.put(getAccountPasswordPath(), body);
};
export var getAccountPersonalInformationPutRequest = function getAccountPersonalInformationPutRequest(_ref) {
    var type = _ref.type, body = _objectWithoutProperties(_ref, _excluded);
    return axios.put(getAccountPath(), body);
};
export var getAccountChangeEmailDeleteRequest = function getAccountChangeEmailDeleteRequest() {
    return axios.delete(getAccountEmailChangePath());
};
export var getResendChangeEmailConfirmation = function getResendChangeEmailConfirmation() {
    return axios.patch(getAccountResendEmailPath());
};
export var getAccountChangeEmailInvitation = function getAccountChangeEmailInvitation(hash) {
    return axios.put(getAccountChangeEmailInvitationPath(hash));
};
